const customs = {
    getlist: 'customs/getlist-by-admin',
    add: 'customs/add',
    update: 'customs/update',
    remove: 'customs/remove',
    get: 'customs/get-by-admin',
    getall: 'customs/getall-by-admin',
    clearcache: 'customs/clear-cache',
}
export default customs
